import { render, staticRenderFns } from "./q-pop-book-ok.vue?vue&type=template&id=09968b8f&scoped=true&"
import script from "./q-pop-book-ok.vue?vue&type=script&lang=js&"
export * from "./q-pop-book-ok.vue?vue&type=script&lang=js&"
import style0 from "./q-pop-book-ok.vue?vue&type=style&index=0&id=09968b8f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09968b8f",
  null
  
)

export default component.exports